import messageEnums from 'enums/messages';
import messageEvents from 'events/messages';
import sessionEvents from 'events/session';

export default function handleMessageSent(message) {
  return (dispatch, getState, { chatGateway }) => {
    const sessionId = chatGateway.getSessionId();

    if (sessionId) {
      dispatch(sessionEvents.sessionUpdateSuccess({ id: sessionId }));
    }

    // we send a message when we update the customer URL and do not want this to show up in the feed
    if (
      message.subType === messageEnums.SUB_TYPES.FILE ||
      message.subType === messageEnums.SUB_TYPES.IMAGE ||
      message.subType === messageEnums.SUB_TYPES.TEXT
    ) {
      dispatch(messageEvents.createOrUpdateMessageSuccess(message));
    }
  };
}
